import React from 'react'
import styled from 'styled-components';
import ProjectBanner from "assets/images/jpgs/ProjectBanner.jpg"
import { TKIconBusDelivery, TKIconDelivery, TKIconLocation } from 'assets/images/svgs'

const Banner = () => {
  return (
    <div>
      <BannerContainer>
        <BannerTextWrapper>
          <h1>ITEM DONATION</h1>
          <p>Two options exist for donating items: one is to contribute directly to a project of your choice, the other is to let TrueKeepers take responsibility and connect your donation to projects that can make use of the item.</p>
          <div className='flex justify-center gap-4'>
            <TKIconDelivery />
            <TKIconLocation />
            <TKIconBusDelivery />
          </div>
        </BannerTextWrapper>
      </BannerContainer>
      <Divider className='w-full h-[5px]'></Divider>
    </div>
  )
}

export default Banner

const BannerContainer = styled.div`
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.765) 15.08%, rgba(0, 0, 0, 0) 62.95%), url(${ProjectBanner});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  height: 480px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Divider = styled.div`
  background: linear-gradient(270deg, #F57200 -94.44%, #F0CA18 108.89%);
`;
const BannerTextWrapper = styled.div`
  width: 40%;
  color: white;
  display: flex;
  position: absolute;
  top: 35%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
  text-align: center;

  @media screen and (max-width: 550px) {
    width: 60%;
  }

  h1 {
    font-weight: 800;
    font-size: 36px;
    line-height: 42px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.08em;
  }
`